import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RfpProfessionalRequiredConditionPossibleGroupTag } from '@/components/modules/pages/rfp/professional/Tag/RfpProfessionalRequiredConditionPossibleGroupTag';
import { RFP_REQUIRED_CONDITION_MEMBER_COMPOSITIONS } from '@/utils/constants/rfp/rfpRequiredCondition/memberComposition';
/**
 * 「プロジェクトで求めていること」で利用するメンバー構成タグ
 * @param props
 * @constructor
 */
export const RfpProfessionalRequiredConditionMemberCompositionPossibleGroupTag = (props) => {
    const { className = '', memberComposition } = props;
    const items = useMemo(() => RFP_REQUIRED_CONDITION_MEMBER_COMPOSITIONS.map((v) => ({
        isPossible: v.value === memberComposition,
        label: (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'hidden md:inline' }, { children: v.label })), _jsx("span", Object.assign({ className: 'inline md:hidden whitespace-pre-line' }, { children: v.labelWithLf }))] })),
    })), [memberComposition]);
    return (_jsx(RfpProfessionalRequiredConditionPossibleGroupTag, { className: className, items: items }));
};
